import React, { Fragment, useState, useEffect } from 'react';
import axios from 'axios';
import { useParams, useHistory, Link } from 'react-router-dom';
import { fetchData, postData, updateData } from '../../../apiService';
import { useAuth } from '../../../AuthContext';
import { tokenIsExpired } from '../../../authUtils';
import Button from '@mui/material/Button';
import CopyrightIcon from '@mui/icons-material/Copyright';
import DoneIcon from '@mui/icons-material/Done';
import CloseIcon from '@mui/icons-material/Close';
import ReplyAllIcon from '@mui/icons-material/ReplyAll';
import Select from 'react-select';
import './create.css';
import AWS from 'aws-sdk';
import { Discount } from '@mui/icons-material';
import { Card, CardContent, Modal } from '@mui/material';
import PrintIcon from '@mui/icons-material/Print';
import IconButton from '@mui/material/IconButton';
import ReactDOM from 'react-dom';
import ReceiptPrint from '../RoomRegister/ReceiptPrint';
import CheckOutReceiptPrint from '../RoomRegister/CheckOutPrint';


const RoomRegisterDetails = () => {

    const { id } = useParams();
    const [isLoading, setIsLoading] = useState(false);
    const { isAuthenticated, companyId, branchId, userId, permissions, token, logout, branchstate } = useAuth();
    const [errorMessage, setErrorMessage] = useState("");
    const history = useHistory();
    const [loading, setLoading] = useState(false);
    const [selectedItems, setSelectedItems] = useState([]);
    const [checkouttime, setcheckouttime] = useState();

    useEffect(() => {
        if (isAuthenticated && tokenIsExpired(token)) {
            logout();
            return;
        }

    }, [isAuthenticated, companyId, branchId, userId, token, logout]);


    useEffect(() => {
        const currentDate = new Date();
        const year = currentDate.getFullYear();
        const month = String(currentDate.getMonth() + 1).padStart(2, '0');
        const day = String(currentDate.getDate()).padStart(2, '0');
        const formattedDate = `${year}-${month}-${day}`;
        setFormData((prevData) => ({
            ...prevData,
            BillDate: formattedDate,
            PaymentTypeId: 1,
        }));
    }, []);

    useEffect(() => {
        // Check if reload is needed based on the flag set in localStorage
        const shouldReload = localStorage.getItem('shouldReloadCreatePage') === 'true';

        if (shouldReload) {
            localStorage.removeItem('shouldReloadCreatePage'); // Remove the flag after use
            window.location.reload(); // Reload the page once
        }

        // Authentication and token expiration handling
        if (isAuthenticated && tokenIsExpired(token)) {
            logout();
            return;
        }
        // Other initializations, if any
    }, [isAuthenticated, token, logout]);

    const formatDateForInput = (dateString) => {
        const currentDate = new Date(dateString);;
        const year = currentDate.getFullYear();
        const month = String(currentDate.getMonth() + 1).padStart(2, '0');
        const day = String(currentDate.getDate()).padStart(2, '0');
        const formattedDate = `${year}-${month}-${day}`;

        return formattedDate;
    };

    const [formData, setFormData] = useState({
        CompanyId: companyId,
        BillDate: "",
        Remarks: "",
        Amount: "",
        BillNo: "",
        FinYear: "",
        createdBy: userId,
        isSubmit: false,
    });

    // DATA RETRIVE


    // useEffect(() => {
    //     fetchData('RoomRegistrationApi', `/RoomRegisterDetails/${id}`, token)
    //         .then((response) => {
    //             setLoading(true);

    //             if (response.responseCode === '1111') {
    //                 const currentDate = new Date().toLocaleDateString('en-CA');

    //                 // ✅ Corrected Stay Calculation Function
    //                 const calculateTotalStay = (checkIn) => {
    //                     const now = new Date(); // current system date and time
    //                     const checkInDate = new Date(checkIn);

    //                     // Base check-in time 11 AM
    //                     const checkIn11AM = new Date(checkInDate);
    //                     checkIn11AM.setHours(11, 0, 0, 0);

    //                     // If check-in time was after 11 AM, start counting from next day
    //                     if (checkInDate.getTime() > checkIn11AM.getTime()) {
    //                         checkIn11AM.setDate(checkIn11AM.getDate() + 1);
    //                     }

    //                     // Today's 11 AM base
    //                     const now11AM = new Date(now);
    //                     now11AM.setHours(11, 0, 0, 0);

    //                     // If current time is after 11 AM, include today
    //                     if (now.getTime() > now11AM.getTime()) {
    //                         now11AM.setDate(now11AM.getDate() + 1);
    //                     }

    //                     const dayDiff = Math.floor((now11AM - checkIn11AM) / (1000 * 60 * 60 * 24));
    //                     return Math.max(1, dayDiff);
    //                 };

    //                 const updatedData = { ...response.response_data };

    //                 if (!updatedData.Isvacated) {
    //                     if (!updatedData.CheckIn) {
    //                         updatedData.CheckIn = currentDate;
    //                     }

    //                     if (updatedData.CheckOut && new Date(updatedData.CheckOut) < new Date(currentDate)) {
    //                         updatedData.CheckOut = currentDate;
    //                     }

    //                     // ✅ Only use CheckIn, and calculate using current system time
    //                     updatedData.TotalStay = updatedData.CheckIn
    //                         ? calculateTotalStay(updatedData.CheckIn)
    //                         : 1;

    //                     const rentAmount = parseFloat(updatedData.RentAmount || 0);
    //                     const discount = parseFloat(updatedData.Discount || 0);
    //                     const gstRate = parseFloat(updatedData.GSTRate || 0);

    //                     const discountedRent = rentAmount - discount;
    //                     const preTaxAmount = updatedData.TotalStay * discountedRent;
    //                     const taxableAmount = preTaxAmount / (1 + gstRate / 100);
    //                     const gstAmount = preTaxAmount - taxableAmount;
    //                     const cgstAmount = gstAmount / 2;
    //                     const sgstAmount = gstAmount / 2;

    //                     updatedData.SlabDiscount = discountedRent.toFixed(2);
    //                     updatedData.FinalAmount = preTaxAmount.toFixed(2);
    //                     updatedData.TaxableAmount = taxableAmount.toFixed(2);
    //                     updatedData.GSTAmount = gstAmount.toFixed(2);
    //                     updatedData.CGSTAmount = cgstAmount.toFixed(2);
    //                     updatedData.SGSTAmount = sgstAmount.toFixed(2);
    //                 }

    //                 setFormData(updatedData);

    //                 if (!updatedData.Isvacated) {
    //                     AutoupdateRecord(updatedData);
    //                 }
    //             }
    //         })
    //         .catch((error) => {
    //             console.error('Error fetching Sale Details:', error);
    //         })
    //         .finally(() => {
    //             setLoading(false);
    //         });
    // }, [id]);

    // Here setting the company check out time wise day calculation - 12:00 pm (CompanyCheckOutTime)
    // useEffect(() => {
    //     fetchData('RoomRegistrationApi', `/RoomRegisterDetails/${id}`, token)
    //         .then((response) => {
    //             setLoading(true);

    //             if (response.responseCode === '1111') {
    //                 const currentDate = new Date().toLocaleDateString('en-CA');
    //                 const updatedData = { ...response.response_data };

    //                 // ✅ Calculate total stay dynamically using CompanyCheckOutTime
    //                 const calculateTotalStay = (checkIn) => {
    //                     const now = new Date(); // current system time
    //                     const checkInDate = new Date(checkIn);

    //                     // CompanyCheckOutTime format expected: "HH:mm:ss"
    //                     const checkoutTimeStr = updatedData.CompanyCheckOutTime || "12:00:00";
    //                     const [hours, minutes, seconds] = checkoutTimeStr.split(':').map(Number);

    //                     // Base check-in time
    //                     const checkInBase = new Date(checkInDate);
    //                     checkInBase.setHours(hours, minutes, seconds, 0);

    //                     // If actual check-in was after base, move to next day
    //                     if (checkInDate.getTime() > checkInBase.getTime()) {
    //                         checkInBase.setDate(checkInBase.getDate() + 1);
    //                     }

    //                     // Current day's base checkout + 1 hour grace
    //                     const nowBase = new Date(now);
    //                     nowBase.setHours(hours + 1, minutes, seconds, 0); // 1 hour grace

    //                     // If current time is past the grace, count today
    //                     if (now.getTime() > nowBase.getTime()) {
    //                         nowBase.setDate(nowBase.getDate() + 1);
    //                     }

    //                     const dayDiff = Math.floor((nowBase - checkInBase) / (1000 * 60 * 60 * 24));
    //                     return Math.max(1, dayDiff);
    //                 };

    //                 if (!updatedData.Isvacated) {
    //                     if (!updatedData.CheckIn) {
    //                         updatedData.CheckIn = currentDate;
    //                     }

    //                     if (updatedData.CheckOut && new Date(updatedData.CheckOut) < new Date(currentDate)) {
    //                         updatedData.CheckOut = currentDate;
    //                     }

    //                     updatedData.TotalStay = updatedData.CheckIn
    //                         ? calculateTotalStay(updatedData.CheckIn)
    //                         : 1;

    //                     const rentAmount = parseFloat(updatedData.RentAmount || 0);
    //                     const discount = parseFloat(updatedData.Discount || 0);
    //                     const gstRate = parseFloat(updatedData.GSTRate || 0);

    //                     const discountedRent = rentAmount - discount;
    //                     const preTaxAmount = updatedData.TotalStay * discountedRent;
    //                     const taxableAmount = preTaxAmount / (1 + gstRate / 100);
    //                     const gstAmount = preTaxAmount - taxableAmount;
    //                     const cgstAmount = gstAmount / 2;
    //                     const sgstAmount = gstAmount / 2;

    //                     updatedData.SlabDiscount = discountedRent.toFixed(2);
    //                     updatedData.FinalAmount = preTaxAmount.toFixed(2);
    //                     updatedData.TaxableAmount = taxableAmount.toFixed(2);
    //                     updatedData.GSTAmount = gstAmount.toFixed(2);
    //                     updatedData.CGSTAmount = cgstAmount.toFixed(2);
    //                     updatedData.SGSTAmount = sgstAmount.toFixed(2);
    //                 }

    //                 setFormData(updatedData);

    //                 if (!updatedData.Isvacated) {
    //                     AutoupdateRecord(updatedData);
    //                 }
    //             }
    //         })
    //         .catch((error) => {
    //             console.error('Error fetching Sale Details:', error);
    //         })
    //         .finally(() => {
    //             setLoading(false);
    //         });
    // }, [id]);


    useEffect(() => {
        fetchData('RoomRegistrationApi', `/RoomRegisterDetails/${id}`, token)
            .then((response) => {
                setLoading(true);

                if (response.responseCode === '1111') {
                    const currentDate = new Date().toLocaleDateString('en-CA');
                    const updatedData = { ...response.response_data };

                    // ✅ Stay Calculation with dynamic checkout + relax time
                    const calculateTotalStay = (checkIn) => {
                        const now = new Date(); // current system time
                        const checkInDate = new Date(checkIn);

                        // Get Company Check-Out Time and RelaxTime
                        const checkoutTimeStr = updatedData.CompanyCheckOutTime || "12:00:00";
                        const relaxTime = parseInt(updatedData.RelaxTime || 0); // in hours

                        const [hours, minutes, seconds] = checkoutTimeStr.split(':').map(Number);

                        // Base check-in threshold
                        const checkInBase = new Date(checkInDate);
                        checkInBase.setHours(hours, minutes, seconds, 0);

                        // If actual check-in time was after the base threshold, move base to next day
                        if (checkInDate.getTime() > checkInBase.getTime()) {
                            checkInBase.setDate(checkInBase.getDate() + 1);
                        }

                        // Current time threshold = checkoutTime + relaxTime
                        const nowBase = new Date(now);
                        nowBase.setHours(hours + relaxTime, minutes, seconds, 0);

                        // If current time is beyond threshold, count today
                        if (now.getTime() > nowBase.getTime()) {
                            nowBase.setDate(nowBase.getDate() + 1);
                        }

                        const dayDiff = Math.floor((nowBase - checkInBase) / (1000 * 60 * 60 * 24));
                        return Math.max(1, dayDiff);
                    };

                    // ✅ Only if not vacated
                    if (!updatedData.Isvacated) {
                        if (!updatedData.CheckIn) {
                            updatedData.CheckIn = currentDate;
                        }

                        if (updatedData.CheckOut && new Date(updatedData.CheckOut) < new Date(currentDate)) {
                            updatedData.CheckOut = currentDate;
                        }

                        updatedData.TotalStay = updatedData.CheckIn
                            ? calculateTotalStay(updatedData.CheckIn)
                            : 1;

                        const rentAmount = parseFloat(updatedData.RentAmount || 0);
                        const discount = parseFloat(updatedData.Discount || 0);
                        const gstRate = parseFloat(updatedData.GSTRate || 0);

                        const discountedRent = rentAmount - discount;
                        const preTaxAmount = updatedData.TotalStay * discountedRent;
                        const taxableAmount = preTaxAmount / (1 + gstRate / 100);
                        const gstAmount = preTaxAmount - taxableAmount;
                        const cgstAmount = gstAmount / 2;
                        const sgstAmount = gstAmount / 2;

                        updatedData.SlabDiscount = discountedRent.toFixed(2);
                        updatedData.FinalAmount = preTaxAmount.toFixed(2);
                        updatedData.TaxableAmount = taxableAmount.toFixed(2);
                        updatedData.GSTAmount = gstAmount.toFixed(2);
                        updatedData.CGSTAmount = cgstAmount.toFixed(2);
                        updatedData.SGSTAmount = sgstAmount.toFixed(2);
                    }

                    setFormData(updatedData);

                    if (!updatedData.Isvacated) {
                        AutoupdateRecord(updatedData);
                    }
                }
            })
            .catch((error) => {
                console.error('Error fetching Sale Details:', error);
            })
            .finally(() => {
                setLoading(false);
            });
    }, [id]);



    const AutoupdateRecord = (updatedData) => {
        const registered = {
            ...updatedData,
            TotalStay: updatedData.TotalStay,
            BranchId: branchId,
            CompanyId: companyId,
            UpdatedBy: userId,
        };

        try {
            updateData('RoomRegistrationApi', `${id}`, registered, token);
        } catch (error) {
            console.error('Error updating record:', error);
        }
    };



    const [viewportWidth, setViewportWidth] = useState(window.innerWidth);

    useEffect(() => {
        const handleResize = () => setViewportWidth(window.innerWidth);
        window.addEventListener('resize', handleResize);

        // Cleanup event listener on component unmount
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    const [formDataReceipt, setFormDataReceipt] = useState({
        CompanyId: companyId,
        BillDate: "",
        Remarks: "",
        Amount: "",
        PaymentTypeId: "1",
        BillNo: "",
        FinYear: "",
        createdBy: userId,
        isSubmit: false,
        BalanceAmount: '',
        PaidAmount: '',
        ReceiptType: '',
    });

    const handleChange = (event) => {
        const { name, value } = event.target;

        setFormData((prevFormData) => {
            // const formattedCurrentDate = new Date().toISOString().split('T')[0];
            const formattedCurrentDate = new Date().toLocaleDateString('en-CA');

            // Ensure TotalStay is an integer
            const calculateTotalStay = (checkIn, checkOut) => {
                if (checkIn && checkOut) {
                    const checkInDate = new Date(checkIn);
                    const checkOutDate = new Date(checkOut);
                    // Round to the nearest integer
                    return Math.max(0, Math.floor((checkOutDate - checkInDate) / (1000 * 60 * 60 * 24)));
                }
                return 0;
            };

            const updatedData = { ...prevFormData, [name]: value };

            if (prevFormData.CheckIn && updatedData.CheckOut) {
                updatedData.TotalStay = calculateTotalStay(prevFormData.CheckIn, updatedData.CheckOut);
            } else {
                updatedData.TotalStay = "";
                updatedData.FinalAmount = "";
                updatedData.SlabDiscount = "";
            }

            const rentAmount = parseFloat(prevFormData.RentAmount || 0);
            const discount = parseFloat(updatedData.Discount || 0);
            const discountedRent = rentAmount - discount;
            updatedData.SlabDiscount = discountedRent.toFixed(2);
            updatedData.FinalAmount = (updatedData.TotalStay * discountedRent).toFixed(2);

            return updatedData;
        });
    };

    useEffect(() => {
        setcheckouttime("11:00");
    }, []);

    const handleChangeReceipt = event => {
        const { name, value, type, checked } = event.target;
        console.log(name, value);
        setFormDataReceipt(prevFormData => ({
            ...prevFormData,
            [name]: type === 'checkbox' ? (checked ? parseInt(value) : 0) : value,
        }));

        if (name === 'PaidAmount' || name === 'PendingAmount') {
            const calculatedBalanceAmount = (
                (parseFloat(name === 'PendingAmount' ? value : formDataReceipt.PendingAmount) || 0.0) -
                (parseFloat(name === 'PaidAmount' ? value : formDataReceipt.PaidAmount) || 0.0)
            ).toFixed(2);

            setFormDataReceipt((prevFormData) => ({
                ...prevFormData,
                BalanceAmount: calculatedBalanceAmount,

            }));
        }

    };

    const [isModalOpen, setIsModalOpen] = useState(false);

    const toggleModal = () => {
        setIsModalOpen(!isModalOpen);
        fetchmaxbillno();
        fetchData('RoomRentPaymentApi', `/RoomRentPaymentDetails/${id}`, token)
            .then((response) => {
                setLoading(true);
                if (response.responseCode === '1111') {
                    setFormDataReceipt(response.response_data);
                    setFormDataReceipt(prevData => ({
                        ...prevData,
                        CreatedBy: userId,
                        PaymentTypeId: 1,
                    }));
                }
            })
            .catch((error) => {
                console.error('Error fetching Sale Details:', error);
            })
            .finally(() => {
                setLoading(false);
            });
    };

    const [isModalCheckOutOpen, setIsModalCheckOutOpen] = useState(false);

    const [formDataReceiptCheckOut, setFormDataReceiptCheckOut] = useState({
        CompanyId: companyId,
        BillDate: "",
        Remarks: "",
        Amount: "",
        PaymentTypeId: 1,
        BillNo: "",
        FinYear: "",
        createdBy: userId,
        isSubmit: false,
        BalanceAmount: '',
        PaidAmount: '0',
        ReceiptType: '',
        TotalStay: '',
        CalPaidAmount: '',
        CheckOut: '',
        OtherAmount: '',
        TotalAmount: '',
        FinalAmount: '',
        AdditionalDiscount: '',
    });

    // const toggleModal1 = () => {
    //     setIsModalCheckOutOpen(!isModalCheckOutOpen);
    //     fetchmaxbillno();
    //     fetchData('RoomRentPaymentApi', `/RoomRentPaymentDetails/${id}`, token)
    //         .then((response) => {
    //             setLoading(true);
    //             if (response.responseCode === '1111') {
    //                 setFormDataReceiptCheckOut(response.response_data);
    //                 const formattedCurrentDate = new Date().toISOString().split('T')[0];
    //                 setFormDataReceiptCheckOut(prevData => ({
    //                     ...prevData,
    //                     CheckOut: formatDateForInput(formattedCurrentDate),
    //                     CreatedBy: userId,
    //                     PaymentTypeId: 1,
    //                 }));
    //             }
    //         })
    //         .catch((error) => {
    //             console.error('Error fetching Sale Details:', error);
    //         })
    //         .finally(() => {
    //             setLoading(false);
    //         });
    // };

    const toggleModal1 = () => {
        setIsModalCheckOutOpen(!isModalCheckOutOpen);
        fetchmaxbillno();
        setLoading(true);

        fetchData('RoomRentPaymentApi', `/RoomRentPaymentDetails/${id}`, token)
            .then((response) => {
                if (response.responseCode === '1111') {
                    const data = response.response_data;
                    //const formattedCurrentDate = new Date().toISOString().split('T')[0];
                    const formattedCurrentDate = new Date().toLocaleDateString('en-CA');

                    const TotalAmount = data.FinalAmount;
                    const PaidAmount = data.CalPaidAmount;

                    // const stayLength = calculateTotalStay(data.CheckIn, formattedCurrentDate);
                    // const grandTotal = stayLength * formData.RentAmount;

                    const stayLength = data.TotalStay;
                    const grandTotal = data.TotalRoomRent;

                    setFormDataReceiptCheckOut({
                        ...data,
                        CheckOut: formattedCurrentDate,
                        CreatedBy: userId,
                        PaymentTypeId: 1,
                        StayLength: stayLength,
                        GrandTotal: grandTotal,
                        BalanceAmount: grandTotal - PaidAmount,
                        //TotalAmount: TotalAmount

                    });
                }
            })
            .catch((error) => {
                console.error('Error fetching Sale Details:', error);
            })
            .finally(() => {
                setLoading(false);
            });

    };


    // const handleCheckoutChange = (event) => {
    //     const { name, value, type, checked } = event.target;

    //     console.log(name, value); // Debugging output for troubleshooting

    //     setFormDataReceiptCheckOut((prevFormData) => {
    //         const updatedValue = type === "checkbox" ? (checked ? parseInt(value, 10) : 0) : value;

    //         // Calculate PaidAmount and OtherAmount for TotalAmount
    //         const updatedPaidAmount =
    //             name === 'PaidAmount' ? parseFloat(value) || 0.0 : parseFloat(prevFormData.PaidAmount) || 0.0;
    //         const updatedOtherAmount =
    //             name === 'OtherAmount' ? parseFloat(value) || 0.0 : parseFloat(prevFormData.OtherAmount) || 0.0;

    //         const calculatedTotalAmount = (updatedPaidAmount + updatedOtherAmount).toFixed(2);

    //         // Calculate FinalAmount and BalanceAmount
    //         const updatedFinalAmount = (parseFloat(prevFormData.FinalAmount) || 0.0) + updatedOtherAmount;
    //         const updatedBalanceAmount = (parseFloat(prevFormData.BalanceAmount) || 0.0) + updatedOtherAmount;

    //         let updatedData = {
    //             ...prevFormData,
    //             [name]: updatedValue,
    //             TotalAmount: calculatedTotalAmount,
    //             FinalAmount: updatedFinalAmount,
    //             BalanceAmount: updatedBalanceAmount,
    //         };

    //         // Calculate Stay Length and Grand Total when CheckOut is changed
    //         if (name === 'CheckOut') {
    //             const newStayLength = calculateTotalStay(prevFormData.CheckIn, value);
    //             updatedData.StayLength = newStayLength;
    //             updatedData.GrandTotal = newStayLength * prevFormData.RentAmount;
    //         }

    //         return updatedData;
    //     });
    // };

    // const calculateTotalStay = (checkIn, checkOut) => {
    //     if (checkIn && checkOut) {
    //         const checkInDate = new Date(checkIn);
    //         const checkOutDate = new Date(checkOut);

    //         // Difference in days, rounded down
    //         return Math.max(
    //             1,
    //             Math.floor((checkOutDate - checkInDate) / (1000 * 60 * 60 * 24))
    //         );
    //     }
    //     return 1;
    // };


    // const handleCheckoutChange = (event) => {
    //     const { name, value, type, checked } = event.target;

    //     console.log(name, value); // Debugging output

    //     setFormDataReceiptCheckOut((prevFormData) => {
    //         const updatedValue = type === "checkbox" ? (checked ? parseInt(value, 10) : 0) : value;

    //         // Parse existing values safely
    //         const prevPaidAmount = parseFloat(prevFormData.PaidAmount) || 0.0;
    //         const prevOtherAmount = parseFloat(prevFormData.OtherAmount) || 0.0;
    //         const prevAdditionalDiscountAmount = parseFloat(prevFormData.AdditionalDiscount) || 0.0;
    //         //Upadte paid amount value
    //         const updatedPaidAmount = name === 'PaidAmount' ? parseFloat(value) || 0.0 : prevPaidAmount;
    //         //update other amount value
    //         const updatedOtherAmount = name === 'OtherAmount' ? parseFloat(value) || 0.0 : prevOtherAmount;
    //         // update additional discount value 
    //         const updatedAdditionalDiscount = name === 'AdditionalDiscount' ? parseFloat(value) || 0.0 : prevAdditionalDiscountAmount;
    //         //update final amount value
    //         const calculatedTotalAmount = (updatedPaidAmount + updatedOtherAmount).toFixed(2);

    //         let updatedData = {
    //             ...prevFormData,
    //             [name]: updatedValue,
    //             BalanceAmount: (parseFloat(prevFormData.BalanceAmount) || 0.0) - updatedAdditionalDiscount,
    //             PaidAmount: updatedPaidAmount,
    //             OtherAmount: updatedOtherAmount,
    //             TotalAmount: calculatedTotalAmount,
    //             AdditionalDiscount: updatedAdditionalDiscount,
    //         };

    //         // Recalculate Stay Length and Grand Total when CheckOut changes
    //         if (name === 'CheckOut') {
    //             const newStayLength = calculateTotalStay(prevFormData.CheckIn, value);
    //             const rent = parseFloat(prevFormData.RentAmount) || 0.0;
    //             updatedData.StayLength = newStayLength;
    //             updatedData.GrandTotal = (newStayLength * rent).toFixed(2);
    //         }

    //         return updatedData;
    //     });
    // };



    // ✅ Custom Stay Length Calculation - with 11:00 AM logic

    const handleCheckoutChange = (event) => {
        const { name, value, type, checked } = event.target;

        setFormDataReceiptCheckOut((prevFormData) => {
            const updatedValue = type === "checkbox" ? (checked ? parseInt(value, 10) : 0) : value;

            const prevPaidAmount = parseFloat(prevFormData.PaidAmount) || 0;
            const prevOtherAmount = parseFloat(prevFormData.OtherAmount) || 0;
            const prevAdditionalDiscount = parseFloat(prevFormData.AdditionalDiscount) || 0;
            const grandTotal = parseFloat(prevFormData.GrandTotal) || 0;

            const updatedPaidAmount = name === 'PaidAmount' ? parseFloat(value) || 0 : prevPaidAmount;
            const updatedOtherAmount = name === 'OtherAmount' ? parseFloat(value) || 0 : prevOtherAmount;
            const updatedAdditionalDiscount = name === 'AdditionalDiscount' ? parseFloat(value) || 0 : prevAdditionalDiscount;

            const updatedTotalAmount = (updatedPaidAmount + updatedOtherAmount).toFixed(2);
            const AdvanceAmount = parseFloat(prevFormData.CalPaidAmount) || 0;
            const updatedBalance = (grandTotal - AdvanceAmount - updatedPaidAmount - updatedAdditionalDiscount).toFixed(2);

            let updatedData = {
                ...prevFormData,
                [name]: updatedValue,
                PaidAmount: updatedPaidAmount,
                OtherAmount: updatedOtherAmount,
                TotalAmount: updatedTotalAmount,
                AdditionalDiscount: updatedAdditionalDiscount,
                BalanceAmount: updatedBalance,
            };

            if (name === 'CheckOut') {
                //const newStayLength = calculateTotalStay(prevFormData.CheckIn, value);
                const newStayLength = formDataReceiptCheckOut.StayLength;
                // const rent = parseFloat(prevFormData.RentAmount) || 0;
                // const newGrandTotal = (newStayLength * rent).toFixed(2);

                const newGrandTotal = parseFloat(prevFormData.FinalAmount) || 0;
                const AdvanceAmount = parseFloat(prevFormData.CalPaidAmount) || 0;
                updatedData.GrandTotal = newGrandTotal;
                updatedData.StayLength = newStayLength;
                //updatedData.GrandTotal = newGrandTotal;
                updatedData.BalanceAmount = (newGrandTotal - AdvanceAmount - updatedPaidAmount - updatedAdditionalDiscount).toFixed(2);
            }

            return updatedData;
        });
    };


    const calculateTotalStay = (checkIn, checkOut) => {
        if (checkIn && checkOut) {
            const checkInDate = new Date(checkIn);
            const checkOutDate = new Date(checkOut);

            const checkInBase = new Date(checkInDate);
            checkInBase.setHours(11, 0, 0, 0);

            const checkOutBase = new Date(checkOutDate);
            checkOutBase.setHours(11, 0, 0, 0);

            let dayDiff = Math.floor((checkOutBase - checkInBase) / (1000 * 60 * 60 * 24));

            // If checkout is after 11 AM, count one extra day
            if (checkOutDate.getTime() > checkOutBase.getTime()) {
                dayDiff += 1;
            }

            return Math.max(1, dayDiff);
        }
        return 1;
    };


    const fetchmaxbillno = () => {
        // Use the parameter directly, no need to rely on formData here
        fetchData('RoomRegistrationApi', `/MaxBillno/${companyId}/${branchId}`, token)
            .then((response) => response.response_data)
            .then((data) => {
                const currentDate = new Date();
                const year = currentDate.getFullYear();
                const month = String(currentDate.getMonth() + 1).padStart(2, '0');
                const day = String(currentDate.getDate()).padStart(2, '0');
                const formattedDate = `${year}-${month}-${day}`;

                // Update formData with the fetched data
                setFormData((prevData) => ({
                    ...prevData,
                    BillNumber: data.BillNumber,
                    BillDate: formattedDate,
                    FinYear: data.FinYear,
                    BranchId: branchId,
                    CompanyId: companyId,
                    PendingAmount: formData.FinalAmount,
                    BalanceAmount: formData.FinalAmount
                }));
            })
            .catch((error) => {
                console.error('Error fetching Max Billno:', error);
            });
    };

    useEffect(() => {
        fetchmaxbillno();
    }, []);


    // Update the Customer entry screens
    const updateRecord = async (event) => {
        //  event.preventDefault();

        const registered = {
            ...formData,
            // TotalStay: String(formData.TotalStay),
            TotalStay: formData.TotalStay,
            BranchId: branchId,
            CompanyId: companyId,
            UpdatedBy: userId,
        };

        try {
            await updateData('RoomRegistrationApi', `${id}`, registered, token);
            setFormData({
                CompanyId: companyId,
                BranchId: branchId,
                UpdatedBy: userId
            });
            window.location.reload(); // Refresh the window after update
        } catch (error) {
            console.error('Error updating record:', error);
        }
    };

    // add the receipt data     
    const AddRecord = async (event) => {
        if (!formDataReceipt.PaidAmount || isNaN(formDataReceipt.PaidAmount)) {
            console.error('PaidAmount is missing or not a valid number.');
            return alert('Please provide a valid PaidAmount.');
        }

        let receiptType = formDataReceipt.ReceiptType || "Advance";
        let PaymentTypeId = formDataReceipt.PaymentTypeId || 1;

        const roomRent = {
            Id: 0,
            RoomRegisterId: id,
            RoomId: formData.RoomId,
            Amount: parseFloat(formDataReceipt.PaidAmount),
            TotalAmount: parseFloat(formDataReceipt.PaidAmount),
            BranchId: branchId,
            CompanyId: companyId,
            CreatedBy: userId,
            BillNo: parseInt(formData.BillNumber, 10),
            BillDate: formData.BillDate,
            PaymentTypeId: PaymentTypeId,
            FinYear: formData.FinYear,
            ReceiptType: receiptType,
        };

        try {
            await postData('RoomRentPaymentApi', roomRent, token)
                .then((response) => {
                    const receiptId = response.kotId;
                    handlePrint(receiptId); // Print the receipt
                    fetchtableReceiptDetails();
                    toggleModal();
                })
                .catch((error) => {
                    console.error('Error updating record:', error);
                    alert('Failed to add the record. Please try again.');
                });
        } catch (error) {
            console.error('Error updating record:', error);
            if (error.response && error.response.data) {
                console.error('Validation Errors:', error.response.data.errors);
                alert(`Error: ${error.response.data.title}`);
            } else {
                alert('An unexpected error occurred. Please try again.');
            }
        }
    };



    const AddCheckOut = async (event) => {
        //  event.preventDefault();

        const currentDate = new Date();
        // const formattedDate = currentDate.toISOString().split('T')[0];
        const formattedDate = currentDate.toLocaleDateString('en-CA');
        const formattedTime = currentDate.toTimeString().split(' ')[0];

        // if (parseFloat(formDataReceiptCheckOut.PaidAmount || 0) !== parseFloat(formDataReceiptCheckOut.BalanceAmount || 0)) {
        //     console.error('PaidAmount does not match BalanceAmount.');
        //     return alert('PaidAmount must be equal to BalanceAmount.');
        // }


        let receiptType = formDataReceiptCheckOut.ReceiptType || "Advance";
        let PaymentTypeId = formDataReceiptCheckOut.PaymentTypeId || 1;
        let staylength = formDataReceiptCheckOut.StayLength;

        const roomRent = {
            Id: 0,
            RoomRegisterId: id,
            RoomId: formData.RoomId,
            Amount: parseFloat(formDataReceiptCheckOut.PaidAmount),
            OtherAmount: parseFloat(formDataReceiptCheckOut.OtherAmount),
            TotalAmount: parseFloat(formDataReceiptCheckOut.TotalAmount),
            AdditionalDiscount: parseFloat(formDataReceiptCheckOut.AdditionalDiscount),
            BranchId: branchId,
            CompanyId: companyId,
            CreatedBy: userId,
            BillNo: parseInt(formData.BillNumber, 10),
            BillDate: formData.BillDate,
            PaymentTypeId: PaymentTypeId,
            FinYear: formData.FinYear,
            ReceiptType: receiptType,
            CheckOut: formattedDate,
            CheckOutTime: formattedTime,
            TotalStay: staylength,

        };

        try {

            //await postData('CheckOutApi', roomRent, token);

            await postData('CheckOutApi', roomRent, token)
                .then((response) => {
                    const receiptId = response.kotId;
                    handlePrintCheckout(receiptId);
                    history.push('/Home');
                })
                .catch((error) => {
                    console.error('Error updating record:', error);
                });

        } catch (error) {
            console.error('Error updating record:', error);
            if (error.response && error.response.data) {
                console.error('Validation Errors:', error.response.data.errors);
                alert(`Error: ${error.response.data.title}`);
            } else {
                alert('An unexpected error occurred. Please try again.');
            }
        }
    };

    // for receipt details
    useEffect(() => {
        fetchtableReceiptDetails();
    }, []);

    const [ReceiptDetails, setReceiptDetails] = useState([]);
    const fetchtableReceiptDetails = async () => {
        try {
            setReceiptDetails([])
            const response = await fetchData('RoomRentPaymentApi', `/ReceiptDataDetails/${id}`, token);
            if (response.responseCode === '1111') {
                setReceiptDetails(response.response_data);
            }
            console.log(response.response_data);
        } catch (error) {
            console.error('Error fetching item details:', error);
            if (error.response && error.response.status === 401) {
                logout();
            }
        }
    };



    // for Item Details
    const [isModalItemdetailsOpen, setIsModalItemdetailsOpen] = useState(false);
    const [ItemDetails, setItemDetails] = useState({
        Quantity: 1,
    });



    const toggleModal2 = () => {
        setIsModalItemdetailsOpen(!isModalItemdetailsOpen);
        // setClearForm("");
        fetchData('RoomRentPaymentApi', `/ItemDetails/${companyId}/${branchId}`, token)
            .then((response) => {
                setLoading(true);
                if (response.responseCode === '1111') {
                    // Ensure response data is an array
                    setItemDetails(Array.isArray(response.response_data) ? response.response_data : []);
                } else {
                    console.error('Unexpected response code:', response.responseCode);
                    setItemDetails([]); // Set empty array if response is invalid
                }
            })
            .catch((error) => {
                console.error('Error fetching Sale Details:', error);
                setItemDetails([]); // Set empty array in case of error
            })
            .finally(() => {
                setLoading(false);
            });
    };

    // SELECTED ITEM FOR RECEIPTENT USEAGE
    const [selectedItems1, setSelectedItems1] = useState([]);

    // Handle item selection and updates
    const handleItemChange = (itemId, field, value) => {
        setSelectedItems1((prev) => {
            const existingItem = prev.find((item) => item.Id === itemId);

            if (existingItem) {
                if (field === 'Quantity' && (value === '' || value <= 0)) {
                    // Remove the item if Qty is empty or less than or equal to 0
                    return prev.filter((item) => item.Id !== itemId);
                } else {
                    // Update the field if the item is already selected
                    return prev.map((item) =>
                        item.Id === itemId ? { ...item, [field]: value } : item
                    );
                }
            } else if (field === 'Quantity' && value > 0) {
                // Add new item with the field if Qty is valid
                return [...prev, { Id: itemId, [field]: value }];
            }
            return prev; // No changes if the conditions are not met
        });
    };

    // Check if an item is selected
    const isSelected = (itemId) => selectedItems1.some((item) => item.Id === itemId);

    // Handle item selection and updates
    const handleItemSelection = (itemId, isChecked) => {
        setSelectedItems1((prev) => {
            if (isChecked) {
                // Add the item if it is checked
                return [...prev, { Id: itemId, Quantity: 1 }];
            } else {
                // Remove the item if it is unchecked
                return prev.filter((item) => item.Id !== itemId);
            }
        });
    };

    // Submit selected items
    const AddItemRecord = async (event) => {
        if (!selectedItems1 || selectedItems1.length === 0) {
            alert("No items selected.");
            return;
        }

        try {
            // Prepare roomRent records for all selected items
            const roomItemsConsumption1 = selectedItems1.map((item) => ({
                Id: 0,
                ItemId: item.Id,
                RoomRegisterId: id,
                RoomId: formData.RoomId,
                BranchId: branchId,
                CompanyId: companyId,
                CreatedBy: userId,
                Quantity: item.Quantity,
                ConsumptionDate: new Date(),
            }));

            const roomItemsConsumption = {
                Consumption: roomItemsConsumption1,
            };

            // Send the data to the API
            await postData('ItemConsumptionApi', roomItemsConsumption, token)
                .then((response) => {
                    console.log('RoomRegistration Created successfully:', response);
                    alert('Items consumed successfully.');
                    setSelectedItems1([]); // Clear the selection after success
                });
            window.location.reload();
        } catch (error) {
            console.error("Error updating record:", error);
            if (error.response && error.response.data) {
                console.error("Validation Errors:", error.response.data.errors);
                alert(`Error: ${error.response.data.title}`);
            } else {
                alert("An unexpected error occurred. Please try again.");
            }
        }
    };

    // for Item Used by
    useEffect(() => {
        fetchtableItemUsedDetails();
    }, []);

    const [ItemUsedDetails, setItemUsedDetails] = useState([]);
    const fetchtableItemUsedDetails = async () => {
        try {
            const response = await fetchData('ItemConsumptionApi', `/ItemDetails/${id}`, token);
            if (response.responseCode === '1111') {
                setItemUsedDetails(response.response_data);
            }
            console.log(response.response_data);
        } catch (error) {
            console.error('Error fetching item details:', error);
            if (error.response && error.response.status === 401) {
                logout();
            }
        }
    };


    ////FOR Example : 16/01/2025 ,Thruday ( date,dayanme )
    const groupedByDate = ItemUsedDetails?.reduce((acc, item) => {
        // Format the ConsumptionDate as dd/mm/yyyy followed by Day Name
        const formattedDate = new Intl.DateTimeFormat('en-GB', {
            day: '2-digit',
            month: '2-digit',
            year: 'numeric',
        }).format(new Date(item.ConsumptionDate));

        // Get the day name separately
        const dayName = new Intl.DateTimeFormat('en-GB', {
            weekday: 'long', // Adds the day name (e.g., Monday)
        }).format(new Date(item.ConsumptionDate));

        const fullFormattedDate = `${formattedDate} , ${dayName}`;

        if (!acc[fullFormattedDate]) {
            acc[fullFormattedDate] = [];
        }
        acc[fullFormattedDate].push(item);
        return acc;
    }, {});




    const handlePrint = async (receiptId) => {
        try {
            const response = await fetchData('RoomRentPaymentApi', `/ReceiptPrint/${receiptId}/${branchId}`, token);
            const labelData = response.response_data;
            const labelsToPrint = Array.isArray(labelData) ? labelData : [labelData];

            // Create and configure the iframe
            const iframe = document.createElement('iframe');
            iframe.style.display = 'none';
            document.body.appendChild(iframe);

            // Wait for the iframe to initialize
            iframe.onload = () => {
                const iframeDocument = iframe.contentDocument || iframe.contentWindow.document;

                // Create a container element for React rendering
                const container = iframeDocument.createElement('div');
                iframeDocument.body.appendChild(container);

                // Render the ReceiptPrint component into the container
                ReactDOM.render(
                    <ReceiptPrint
                        labelData={labelData}
                        onClose={() => document.body.removeChild(iframe)} // Cleanup
                    />,
                    container
                );

                // Trigger the print function
                setTimeout(() => {
                    iframe.contentWindow.print();
                }, 500); // Short delay to ensure content is rendered
            };

            // Trigger iframe load by opening and closing the document
            const iframeDocument = iframe.contentDocument || iframe.contentWindow.document;
            iframeDocument.open();
            iframeDocument.close();
        } catch (error) {
            console.error('Error printing Invoice:', error);
        }
    };


    // print 
    const handlePrintCheckout = async (receiptId) => {
        try {
            const response = await fetchData('RoomRentPaymentApi', `/ReceiptPrint/${receiptId}/${branchId}`, token);
            const labelData = response.response_data;
            const labelsToPrint = Array.isArray(labelData) ? labelData : [labelData];

            // Create and configure the iframe
            const iframe = document.createElement('iframe');
            iframe.style.display = 'none';
            document.body.appendChild(iframe);

            // Wait for the iframe to initialize
            iframe.onload = () => {
                const iframeDocument = iframe.contentDocument || iframe.contentWindow.document;

                // Create a container element for React rendering
                const container = iframeDocument.createElement('div');
                iframeDocument.body.appendChild(container);

                // Render the CheckOutReceiptPrint component into the container
                ReactDOM.render(
                    <CheckOutReceiptPrint
                        labelData={labelData}
                        onClose={() => document.body.removeChild(iframe)} // Cleanup
                    />,
                    container
                );

                // Trigger the print function
                setTimeout(() => {
                    iframe.contentWindow.print();
                }, 500); // Short delay to ensure content is rendered
            };

            // Trigger iframe load by opening and closing the document
            const iframeDocument = iframe.contentDocument || iframe.contentWindow.document;
            iframeDocument.open();
            iframeDocument.close();
        } catch (error) {
            console.error('Error printing Invoice:', error);
        }
    };

    const formatAMPM = (timeString) => {
        if (!timeString) return 'Not Available';

        const [hours, minutes] = timeString.split(':');
        let hour = parseInt(hours, 10);
        const ampm = hour >= 12 ? 'PM' : 'AM';
        hour = hour % 12 || 12; // Convert 0 to 12 for AM case

        return `${hour}:${minutes} ${ampm}`;
    };

    return (
        <div className="w-full max-w-sm container mt-2 mx-auto" style={{ maxWidth: '91%' }}>

            <style>
                {`
                    .container::-webkit-scrollbar {
                        width: 0.1em;
                    }
                    .container::-webkit-scrollbar-track {
                        background: rgba(255,255,255,0);
                    }
                    .container::-webkit-scrollbar-thumb {
                        background-color: rgba(255,255,255,0);
                        border-radius: 4px;
                    }
                `}
            </style>

            <div className="w-full mb-2 flex items-center justify-between">
                {/* Title Section */}
                <h5
                    style={{
                        color: '#164863',
                        fontWeight: 'bold',
                        fontFamily: 'monospace',
                        textAlign: 'center',
                        marginTop: '1%',
                    }}
                >
                    {/* ROOMS AND TYPES - <span style={{ color: 'red' }}>{formData.RoomName}</span> <span style={{ color: 'black', fontSize: '14px' }}>- Check In Time : {formData.CheckInTime}</span> */}
                    ROOMS AND TYPES - <span style={{ color: 'red' }}>{formData.RoomName}</span>
                    <span style={{ color: 'black', fontSize: '14px', marginLeft: '5px' }}>
                        - Check In Time : {formatAMPM(formData.CheckInTime)}
                    </span>

                </h5>

                {/* Button Section */}
                <div className="flex">
                    {!formData.Isvacated && (
                        <Button
                            variant="contained"
                            style={{
                                marginLeft: '8px',
                                backgroundColor: '#DBB5B5',
                                color: 'white',
                                fontSize: '12px',
                                fontWeight: 'bold'
                            }}
                            onClick={toggleModal2}
                        >
                            ITEM DETAILS
                        </Button>
                    )}

                    {!formData.Isvacated && (
                        <Button
                            variant="contained"
                            style={{
                                marginLeft: '8px',
                                backgroundColor: '#79D7BE',
                                color: 'white',
                                fontSize: '12px',
                                fontWeight: 'bold'
                            }}
                            onClick={toggleModal1}
                        >
                            Check Out
                        </Button>
                    )}

                    {!formData.Isvacated && (
                        <Button
                            variant="contained"
                            style={{
                                marginLeft: '8px',
                                backgroundColor: '#E195AB',
                                color: 'white',
                                fontSize: '12px',
                                fontWeight: 'bold'
                            }}
                            onClick={toggleModal}
                        >
                            Receipt
                        </Button>
                    )}

                    {!formData.Isvacated && (
                        <Button
                            variant="contained"
                            style={{
                                marginLeft: '8px',
                                backgroundColor: '#ABBA7C',
                                color: 'white',
                                fontSize: '12px',
                                fontWeight: 'bold'
                            }}
                            onClick={updateRecord}
                        >
                            Update
                        </Button>
                    )}
                    <Button
                        variant="contained"
                        component={Link}
                        to="/Home"
                        className="linkcolor"
                        style={{ marginLeft: '8px', fontSize: '12px', fontWeight: 'bold', backgroundColor: '#FF8383' }}
                    >
                        Back
                    </Button>
                </div>
            </div>

            {/* <br></br> */}
            <div className="flex flex-wrap justify-between">

                <Card className="w-full sm:w-3/5 mb-4 rounded-lg shadow-lg" style={{ backgroundColor: 'rgba(255, 255, 255, 0)', borderRadius: '10px', marginLeft: '-3%' }}>
                    <CardContent>
                        <div className="w-full mb-4 flex">
                            <div className="w-1/2 mr-2">
                                <label className="block uppercase tracking-wide  text-xs font-bold mb-2" htmlFor="name">
                                    First Name
                                </label>
                                <input className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline h-8"
                                    name='FirstName'
                                    value={formData.FirstName || ''}
                                    onChange={handleChange}
                                    type="text"
                                    placeholder="Enter FirstName"
                                    required

                                />
                            </div>

                            <div className="w-1/2 mr-2">
                                <label className="block uppercase tracking-wide  text-xs font-bold mb-2" htmlFor="name">
                                    Last Name
                                </label>
                                <input className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline h-8"
                                    name='LastName'
                                    value={formData.LastName || ''}
                                    onChange={handleChange}
                                    type="text"
                                    placeholder="Enter LastName"
                                    required

                                />
                            </div>

                            <div className="w-1/2 mr-2">
                                <label className="block uppercase tracking-wide  text-xs font-bold mb-2" htmlFor="name">
                                    Contact Number
                                </label>
                                <input className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline h-8"
                                    name='ContactNumber'
                                    value={formData.ContactNumber}
                                    onChange={handleChange}
                                    type="text"
                                    placeholder="Enter ContactNumber"
                                />
                            </div>




                        </div>

                        <div className="w-full mb-4 flex">
                            <div className="w-1/2 mr-2">
                                <label className="block uppercase tracking-wide  text-xs font-bold mb-2" htmlFor="name">
                                    Email
                                </label>
                                <input className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline h-8"
                                    name='Email'
                                    value={formData.Email}
                                    onChange={handleChange}
                                    type="text"
                                    placeholder="Enter Email"
                                />
                            </div>

                            <div className="w-1/2 mr-2">
                                <label className="block uppercase tracking-wide text-xs font-bold mb-2" htmlFor="total">
                                    ID proof
                                </label>
                                <input
                                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline h-8"
                                    name="ProofName"
                                    value={formData.ProofName}
                                    onChange={handleChange}
                                    type="text"
                                    placeholder="Enter Purpose"
                                    readOnly
                                    style={{ backgroundColor: '#DFF2EB', fontWeight: 'bolder', color: 'black' }}
                                />
                            </div>
                            <div className="w-1/2 mr-2">
                                <label className="block uppercase tracking-wide text-xs font-bold mb-2" htmlFor="total">
                                    Proof No
                                </label>
                                <input
                                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline h-8"
                                    name="AddressproofNo"
                                    value={formData.AddressproofNo}
                                    onChange={handleChange}
                                    type="text"
                                    placeholder="Enter AddressproofNo"
                                    readOnly
                                    style={{ backgroundColor: '#DFF2EB', fontWeight: 'bolder', color: 'black' }}
                                />
                            </div>
                        </div>

                        <div className="w-full mb-4 flex">
                            <div className="w-1/3 mr-2">
                                <label className="block uppercase tracking-wide  text-xs font-bold mb-2" htmlFor="name">
                                    AddressLine 1
                                </label>
                                <textarea className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline h-8"
                                    name='AddressLine1'
                                    value={formData.AddressLine1}
                                    onChange={handleChange}
                                    type="text"
                                    placeholder="Enter AddressLine1"
                                    required
                                    rows={2}
                                />
                            </div>

                            <div className="w-1/3 mr-2">
                                <label className="block uppercase tracking-wide  text-xs font-bold mb-2" htmlFor="name">
                                    AddressLine 2
                                </label>
                                <textarea className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline h-8"
                                    name='AddressLine2'
                                    value={formData.AddressLine2 || ''}
                                    onChange={handleChange}
                                    type="text"
                                    placeholder="Enter AddressLine2"
                                    required
                                    rows={2}
                                />
                            </div>

                            <div className="w-1/3 mr-2">
                                <label className="block uppercase tracking-wide  text-xs font-bold mb-2" htmlFor="name">
                                    Purpose of visit
                                </label>
                                <textarea className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline h-8"
                                    name='Purpose'
                                    value={formData.Purpose}
                                    onChange={handleChange}
                                    type="text"
                                    placeholder="Enter Purpose"
                                    rows={2}
                                />
                            </div>

                        </div>

                        <div className="w-full mb-4 flex">
                            <div className="w-1/2 mr-2">
                                <label
                                    className="block uppercase tracking-wide text-xs font-bold mb-2"
                                    htmlFor="roomType"
                                >
                                    Room Type
                                </label>
                                <input
                                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline h-8"
                                    name="RoomType"
                                    value={formData.SlabName}
                                    onChange={handleChange}
                                    type="text"
                                    placeholder="Enter Room Type"
                                    readOnly
                                    style={{ backgroundColor: '#DFF2EB', fontWeight: 'bolder', color: 'black' }}
                                />
                            </div>

                            <div className="w-1/6 mr-2">
                                <label
                                    className="block uppercase tracking-wide text-xs font-bold mb-2"
                                    htmlFor="rent"
                                >
                                    Rent
                                </label>
                                <input
                                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline h-8"
                                    name="RentAmount"
                                    value={formData.RentAmount}
                                    onChange={handleChange}
                                    type="text"
                                    placeholder="Enter Rent"
                                    required
                                    readOnly
                                    style={{ backgroundColor: '#DFF2EB', fontWeight: 'bolder', color: 'black', textAlign: 'right' }}
                                />
                            </div>

                            <div className="w-1/7 mr-2">
                                <label
                                    className="block uppercase tracking-wide text-xs font-bold mb-2"
                                    htmlFor="discount"
                                >
                                    Discount
                                </label>
                                <input
                                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline h-8"
                                    name="Discount"
                                    value={`${formData.Discount || '0'}`}
                                    onChange={handleChange}
                                    type="text"
                                    placeholder="Enter Discount"
                                    maxLength={50}
                                    onClick={(e) => e.target.select()}
                                    style={{ textAlign: 'right' }}
                                    disabled
                                />
                            </div>

                            <div className="w-1/7 mr-2">
                                <label
                                    className="block uppercase tracking-wide text-xs font-bold mb-2"
                                    htmlFor="total"
                                >
                                    Total
                                </label>
                                <input
                                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline h-8"
                                    name="SlabDiscount"
                                    value={formData.SlabDiscount}
                                    onChange={handleChange}
                                    type="text"
                                    placeholder="Enter Total"
                                    readOnly
                                    style={{ backgroundColor: '#DFF2EB', fontWeight: 'bolder', color: 'black', textAlign: 'right' }}
                                />
                            </div>


                        </div>

                        <div className="w-full mb-4 flex">
                            <div className="w-1/4 mr-2">
                                <label
                                    className="block uppercase tracking-wide text-xs font-bold mb-2"
                                    htmlFor="checkIn"
                                >
                                    Check In
                                </label>
                                <input
                                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline h-8"
                                    name="CheckIn"
                                    value={formatDateForInput(formData.CheckIn)}
                                    onChange={handleChange}
                                    type="date"
                                    placeholder="Enter Check In"
                                    readOnly
                                    style={{ backgroundColor: '#DFF2EB', fontWeight: 'bolder', color: 'black' }}
                                />
                            </div>

                            <div className="w-1/4 mr-2">
                                <label
                                    className="block uppercase tracking-wide text-xs font-bold mb-2"
                                    htmlFor="checkOut"
                                >
                                    Check Out
                                </label>
                                <input
                                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline h-8"
                                    name="CheckOut"
                                    value={formatDateForInput(formData.CheckOut)}
                                    onChange={handleChange}
                                    type="date"
                                    placeholder="Enter Check Out"
                                    required
                                    readOnly
                                    style={{ backgroundColor: '#DFF2EB', fontWeight: 'bolder', color: 'black' }}
                                />
                            </div>

                            <div className="w-1/8 mr-2">
                                <label
                                    className="block uppercase tracking-wide text-xs font-bold mb-2"
                                    htmlFor="totalStay"
                                >
                                    Total Stay
                                </label>
                                <input
                                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline h-8"
                                    name="TotalStay"
                                    value={formData.TotalStay}
                                    onChange={handleChange}
                                    type="text"
                                    placeholder="Enter Total Stay"
                                    readOnly
                                    style={{ backgroundColor: '#DFF2EB', fontWeight: 'bolder', color: 'black', textAlign: 'right' }}
                                />
                            </div>

                            <div className="w-1/2 mr-2">
                                <label
                                    className="block uppercase tracking-wide text-xs font-bold mb-2"
                                    htmlFor="grandTotal"
                                >
                                    Grand Total
                                </label>
                                <input
                                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline h-8"
                                    name="FinalAmount"
                                    value={formData.FinalAmount}
                                    onChange={handleChange}
                                    type="text"
                                    placeholder="Enter Grand Total"
                                    required
                                    readOnly
                                    style={{ backgroundColor: '#DFF2EB', fontWeight: 'bolder', color: 'black', textAlign: 'right' }}
                                />
                            </div>
                        </div>
                    </CardContent>
                </Card>

                <Card className="w-full sm:w-1/5 mb-4 rounded-lg shadow-lg" style={{ backgroundColor: 'rgba(255, 255, 255, 0)', borderRadius: '10px', width: '20%', height: '457px', overflowY: 'auto' }}>
                    <CardContent>
                        <h6 style={{
                            color: '#006769',
                            fontWeight: 'bold',
                            fontFamily: 'monospace',
                            textAlign: 'center',
                            marginTop: '1%',
                        }}>
                            ITEMS USED BY RECEIPTENT
                        </h6>

                        {groupedByDate && Object.entries(groupedByDate).map(([date, items]) => (
                            <div key={date} className="date-group">
                                {/* Date Heading */}
                                <h5
                                    style={{
                                        fontSize: '12px',
                                        fontWeight: 'bold',
                                        marginBottom: '10px',
                                        textAlign: 'Center',
                                        color: '#6D2323',
                                    }}
                                >
                                    {date}
                                </h5>

                                {/* Cards for Each Date */}
                                <div className="w-full mb-5" style={{ display: 'flex', flexWrap: 'wrap' }}>
                                    {items.map((item) => (
                                        <Card
                                            key={item.Id}
                                            className="customCard"
                                            style={{
                                                marginBottom: '10px',
                                                background: 'linear-gradient(to right, #D6C0B3, #D6C0B3)',
                                                color: 'black',
                                                marginLeft: '5px',
                                                height: '35px',
                                                boxSizing: 'border-box',
                                                width: '350px',
                                                cursor: 'pointer',
                                            }}
                                        >
                                            <CardContent
                                                style={{
                                                    height: '100%',
                                                    display: 'flex',
                                                    flexDirection: 'column',
                                                    justifyContent: 'space-between',
                                                    alignItems: 'left',
                                                    padding: '10px',
                                                    boxSizing: 'border-box',
                                                }}
                                            >
                                                <div
                                                    style={{
                                                        overflow: 'hidden',
                                                        textOverflow: 'ellipsis',
                                                        fontSize: '12px',
                                                        fontWeight: 'bold',
                                                        textAlign: 'left',
                                                    }}
                                                >
                                                    {item.ItemName} - ( {item.Quantity} )
                                                </div>
                                            </CardContent>
                                        </Card>
                                    ))}
                                </div>
                            </div>
                        ))}
                        {/* </div> */}

                    </CardContent>
                </Card>

                <Card className="w-full sm:w-1/5 mb-4 rounded-lg shadow-lg" style={{ backgroundColor: 'rgba(255, 255, 255, 0)', borderRadius: '10px', width: '20%', height: '457px', overflowY: 'auto' }}>
                    <CardContent>
                        <h6 style={{
                            color: '#8E3E63',
                            fontWeight: 'bold',
                            fontFamily: 'monospace',
                            textAlign: 'center',
                            marginTop: '1%',
                        }}>
                            RECEIPT UNDER RECEIPTENT
                        </h6>
                        <div className='w-full mb-5' style={{ display: 'flex', flexWrap: 'wrap' }}>
                            {ReceiptDetails && ReceiptDetails.map((item) => (
                                <Card key={item.Id} className="customCard" style={{
                                    marginBottom: '10px',
                                    background: 'linear-gradient(to right, #C9E9D2, #C9E9D2)',
                                    color: 'black',
                                    marginLeft: '20px',
                                    height: '60px',
                                    boxSizing: 'border-box',
                                    width: '300px',
                                    cursor: 'pointer'
                                }}

                                >
                                    <CardContent style={{
                                        height: '100%',
                                        display: 'flex',
                                        flexDirection: 'column',
                                        justifyContent: 'space-between',
                                        alignItems: 'left',
                                        padding: '10px',
                                        boxSizing: 'border-box'
                                    }}>

                                        <div style={{
                                            overflow: 'hidden',
                                            textOverflow: 'ellipsis',
                                            fontSize: '12px',
                                            fontWeight: 'bold',
                                            textAlign: 'left'
                                        }}>
                                            <div style={{ marginBottom: '4px' }}>
                                                Bill No: {item.BillNo}/{item.FinYear}
                                            </div>
                                            <div style={{
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'space-between',
                                                marginTop: '-5px'
                                            }}>
                                                <span style={{ marginRight: 'auto' }}>
                                                    RS: {item.Amount}/-
                                                    {item.PaymentTypeId === 1 && " (Cash)"}
                                                    {item.PaymentTypeId === 2 && " (Cheque)"}
                                                    {item.PaymentTypeId === 3 && " (UPI)"}
                                                </span>
                                                <IconButton onClick={() => handlePrint(item.Id)}>
                                                    <PrintIcon style={{
                                                        height: '19px',
                                                        color: 'darkmagenta',
                                                        marginTop: '-5px'
                                                    }} />
                                                </IconButton>
                                            </div>
                                        </div>

                                    </CardContent>
                                </Card>
                            ))}
                        </div>
                    </CardContent>
                </Card>

            </div>

            {
                isModalOpen && (
                    <div className="fixed inset-0 flex items-center justify-center z-10">
                        <div className="bg-white p-6 rounded-lg shadow-lg" style={{ width: '55%' }}>
                            <h6 style={{ color: 'brown', textAlign: 'center', fontWeight: 'bolder', marginLeft: '20%' }}>RECEIPT   <span style={{ textAlign: 'right', marginLeft: '20%', color: '#001A6E' }}>Grand Total {formData.FinalAmount || '0.00'}</span></h6>
                            <div className="w-full mb-4 flex" style={{ marginTop: '1.50%' }}>
                                <div className="w-1/4 mr-2">
                                    <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="name">
                                        Receiptent Name
                                    </label>
                                    <input
                                        className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline h-9"
                                        type="text"
                                        value={`${formData.FirstName}  ${formData.LastName}`}
                                    />
                                </div>
                                <div className="w-1/5 mr-2">
                                    <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="name">
                                        Bill Date
                                        <span className="text-red-500">*</span>
                                    </label>
                                    <input
                                        className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline h-9"
                                        value={formatDateForInput(formData.BillDate)}
                                        type="date"
                                        placeholder="Enter Reference Date"
                                        name='BillDate'
                                        onChange={handleChangeReceipt}
                                    />
                                </div>

                                <div className="w-1/5 mr-2">
                                    <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="name">
                                        Bill Number
                                        <span className="text-red-500">*</span>
                                    </label>
                                    <input
                                        className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline h-9"
                                        value={`${formData.BillNumber || ''}/${formData.FinYear || ''}`}
                                        type="text"
                                        placeholder="Enter BillNo"
                                        name='BillNo'
                                        readOnly
                                        onChange={handleChangeReceipt}
                                    />
                                </div>

                                <div className="mr-2" style={{ width: '300px' }}>
                                    <label
                                        className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
                                        htmlFor="receiptType"
                                    >
                                        Receipt Type
                                    </label>
                                    <select
                                        id="receiptType"
                                        className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline h-9"
                                        value={formDataReceipt.ReceiptType || "Advance"}
                                        onChange={(e) =>
                                            setFormDataReceipt({
                                                ...formDataReceipt,
                                                ReceiptType: e.target.value,
                                            })
                                        }
                                    >
                                        <option value="" disabled>
                                            Select Receipt Type
                                        </option>
                                        <option value="Advance">Advance</option>
                                        <option value="Receipt">Receipt</option>
                                        {/* <option value="Other Amount">Other Amount</option> */}
                                    </select>
                                </div>


                            </div>
                            <div className="w-full mb-4 flex">
                                {formDataReceipt.ReceiptType !== "Other Amount" && (
                                    <div className="w-1/4 mr-2">
                                        <label
                                            className="block uppercase tracking-wide text-xs font-bold mb-2"
                                            htmlFor="grandTotal"
                                        >
                                            Pending Amount
                                        </label>
                                        <input
                                            className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline h-9"
                                            name="PendingAmount"
                                            value={formDataReceipt.PendingAmount || '0'}
                                            onChange={handleChangeReceipt}
                                            type="text"
                                            placeholder="Enter Grand Total"
                                            required
                                            readOnly
                                            style={{ textAlign: 'right' }}
                                        />
                                    </div>
                                )}

                                <div className="w-1/4 mr-2">
                                    <label
                                        className="block uppercase tracking-wide text-xs font-bold mb-2"
                                        htmlFor="grandTotal"
                                    >
                                        Paid Amount
                                    </label>
                                    <input
                                        className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline h-9"
                                        name="PaidAmount"
                                        value={formDataReceipt.PaidAmount}
                                        onChange={(e) => {
                                            const newValue = parseFloat(e.target.value) || 0;
                                            const pendingAmount = parseFloat(formDataReceipt.PendingAmount) || 0;

                                            if (newValue <= Math.max(0, pendingAmount)) {
                                                handleChangeReceipt(e); // Directly call handleChangeReceipt
                                            }
                                        }}
                                        type="number"
                                        placeholder="Enter Grand Total"
                                        required
                                        style={{ textAlign: 'right' }}
                                        max={formData.PendingAmount}
                                        onClick={(e) => e.target.select()}
                                    />
                                </div>
                                {formDataReceipt.ReceiptType !== "Other Amount" && (
                                    <div className="w-1/4 mr-2">
                                        <label
                                            className="block uppercase tracking-wide text-xs font-bold mb-2"
                                            htmlFor="grandTotal"
                                        >
                                            Balance  Amount
                                        </label>
                                        <input
                                            className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline h-9"
                                            name="BalanceAmount"
                                            value={formDataReceipt.BalanceAmount}
                                            onChange={handleChangeReceipt}
                                            type="text"
                                            placeholder="Enter Grand Total"
                                            required
                                            readOnly
                                            style={{ textAlign: 'right' }}
                                        />
                                    </div>
                                )}

                                <label className="block tracking-wide text-gray-700 font-bold mr-2" style={{ color: 'green' }}>
                                    <input
                                        type="checkbox"
                                        name="PaymentTypeId"
                                        value="1"
                                        checked={formDataReceipt.PaymentTypeId === 1}
                                        onChange={handleChangeReceipt}
                                    />
                                    Cash
                                </label>
                                <label className="block tracking-wide text-gray-700 font-bold mr-2" style={{ color: 'blue' }}>
                                    <input
                                        type="checkbox"
                                        name="PaymentTypeId"
                                        value="2"
                                        checked={formDataReceipt.PaymentTypeId === 2}
                                        onChange={handleChangeReceipt}
                                    />
                                    Cheque
                                </label>
                                <label className="block tracking-wide text-gray-700 font-bold" style={{ color: 'brown' }}>
                                    <input
                                        type="checkbox"
                                        name="PaymentTypeId"
                                        value="3"
                                        checked={formDataReceipt.PaymentTypeId === 3}
                                        onChange={handleChangeReceipt}
                                    />
                                    UPI
                                </label>
                            </div>

                            <div className="w-1/2 mr-4" style={{ marginTop: '23px' }}>
                                <button
                                    variant="contained"
                                    className="bg-green-700 text-white px-4 py-2 rounded"
                                    onClick={AddRecord}
                                    style={{ marginLeft: '8px', fontSize: '12px', fontWeight: 'bold' }}
                                >
                                    ADD RECORD
                                </button>
                                <button
                                    variant="contained"
                                    className="bg-orange-500 text-white px-4 py-2 rounded ml-2"
                                    onClick={toggleModal}
                                    style={{ marginLeft: '8px', fontSize: '12px', fontWeight: 'bold' }}
                                >
                                    CANCEL
                                </button>
                            </div>
                        </div>
                    </div>
                )
            }

            {
                isModalCheckOutOpen && (
                    <div className="fixed inset-0 flex items-center justify-center z-10">
                        <div className="bg-white p-6 rounded-lg shadow-lg" style={{ width: '59%' }}>
                            <h6 style={{ color: 'brown', textAlign: 'center', fontWeight: 'bolder' }}>CHECK OUT & VACATE </h6>
                            <div className="w-full mb-4 flex" style={{ marginTop: '1.50%', textAlign: 'center', justifyContent: 'right' }}>
                                <label className="block tracking-wide text-gray-700 font-bold mr-2" style={{ color: 'green' }}>
                                    <input
                                        type="checkbox"
                                        name="PaymentTypeId"
                                        value="1"
                                        checked={formDataReceiptCheckOut.PaymentTypeId === 1}
                                        onChange={handleCheckoutChange}
                                    />
                                    Cash
                                </label>
                                <label className="block tracking-wide text-gray-700 font-bold mr-2" style={{ color: 'blue' }}>
                                    <input
                                        type="checkbox"
                                        name="PaymentTypeId"
                                        value="2"
                                        checked={formDataReceiptCheckOut.PaymentTypeId === 2}
                                        onChange={handleCheckoutChange}
                                    />
                                    Cheque
                                </label>
                                <label className="block tracking-wide text-gray-700 font-bold" style={{ color: 'brown' }}>
                                    <input
                                        type="checkbox"
                                        name="PaymentTypeId"
                                        value="3"
                                        checked={formDataReceiptCheckOut.PaymentTypeId === 3}
                                        onChange={handleCheckoutChange}
                                    />
                                    UPI
                                </label>
                            </div>
                            <div className="w-full mb-4 flex" style={{ marginTop: '1.50%' }}>
                                <div className="w-3/5 mr-2">
                                    <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="name">
                                        Receiptent Name
                                    </label>
                                    <input
                                        className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline h-9"
                                        type="text"
                                        value={`${formData.FirstName}  ${(formData.LastName) || ""}`}
                                        disabled
                                        style={{ backgroundColor: '#DFF2EB' }}
                                    />
                                </div>
                                <div className="w-1/5 mr-2">
                                    <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="name">
                                        Bill Date
                                        <span className="text-red-500">*</span>
                                    </label>
                                    <input
                                        className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline h-9"
                                        value={formatDateForInput(formData.BillDate)}
                                        type="date"
                                        placeholder="Enter Reference Date"
                                        name='BillDate'
                                        onChange={handleChangeReceipt}
                                        disabled
                                        style={{ backgroundColor: '#DFF2EB' }}
                                    />
                                </div>

                                <div className="w-1/5 mr-2">
                                    <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="name">
                                        Bill Number
                                        <span className="text-red-500">*</span>
                                    </label>
                                    <input
                                        className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline h-9"
                                        value={`${formData.BillNumber || ''}/${formData.FinYear || ''}`}
                                        type="text"
                                        placeholder="Enter BillNo"
                                        name='BillNo'
                                        disabled
                                        onChange={handleChangeReceipt}
                                        style={{ backgroundColor: '#DFF2EB' }}
                                    />
                                </div>


                            </div>
                            <div className="w-full mb-4 flex">
                                <div className="w-1/4 mr-2">
                                    <label
                                        className="block uppercase tracking-wide text-xs font-bold mb-2"
                                        htmlFor="checkIn"
                                    >
                                        Check In
                                    </label>
                                    <input
                                        className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline h-9"
                                        name="CheckIn"
                                        value={formatDateForInput(formData.CheckIn)}
                                        onChange={handleChange}
                                        type="date"
                                        placeholder="Enter Check In"
                                        disabled
                                        style={{ backgroundColor: '#DFF2EB' }}
                                    />
                                </div>

                                <div className="w-1/4 mr-2">
                                    <label
                                        className="block uppercase tracking-wide text-xs font-bold mb-2"
                                        htmlFor="checkOut"
                                    >
                                        Check Out
                                    </label>
                                    <input
                                        className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline h-9"
                                        name="CheckOut"
                                        value={formatDateForInput(formDataReceiptCheckOut.CheckOut)}
                                        onChange={handleCheckoutChange}
                                        type="date"
                                        placeholder="Enter Check Out"
                                        required
                                        disabled
                                        style={{ backgroundColor: '#DFF2EB' }}
                                    />
                                </div>

                                <div className="w-1/4 mr-2">
                                    <label
                                        className="block uppercase tracking-wide text-xs font-bold mb-2"
                                        htmlFor="grandTotal"
                                    >
                                        Stay Length
                                    </label>
                                    <input
                                        className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline h-9"
                                        name="TotalStay"
                                        value={formDataReceiptCheckOut.TotalStay || ''}
                                        onChange={handleCheckoutChange}
                                        type="text"
                                        placeholder="Enter StayLength"
                                        required
                                        disabled
                                        style={{ backgroundColor: '#DFF2EB', fontWeight: 'bolder', color: 'black', textAlign: 'right' }}
                                    />
                                </div>

                                <div className="w-1/4 mr-2">
                                    <label
                                        className="block uppercase tracking-wide text-xs font-bold mb-2"
                                        htmlFor="grandTotal"
                                    >
                                        Grand Total
                                    </label>
                                    <input
                                        className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline h-9"
                                        name="GrandTotal"
                                        value={formDataReceiptCheckOut.GrandTotal}
                                        onChange={handleCheckoutChange}
                                        type="text"
                                        placeholder="Enter Grand Total"
                                        required
                                        disabled
                                        style={{ backgroundColor: '#DFF2EB', fontWeight: 'bolder', color: 'black', textAlign: 'right' }}
                                    />
                                </div>

                                <div className="w-1/4 mr-2">
                                    <label
                                        className="block uppercase tracking-wide text-xs font-bold mb-2"
                                        htmlFor="grandTotal"
                                    >
                                        Advance Amount
                                    </label>
                                    <input
                                        className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline h-9"
                                        name="CalPaidAmount"
                                        value={formDataReceiptCheckOut.CalPaidAmount || '0'}
                                        onChange={handleCheckoutChange}
                                        type="text"
                                        placeholder="Enter Grand Total"
                                        required
                                        disabled
                                        style={{ backgroundColor: '#DFF2EB', fontWeight: 'bolder', color: 'black', textAlign: 'right' }}
                                    />
                                </div>

                            </div>
                            <div className="w-full mb-4 flex">

                                <div className="w-1/4 mr-2">
                                    <label
                                        className="block uppercase tracking-wide text-xs font-bold mb-2"
                                        htmlFor="grandTotal"
                                    >
                                        Balance Amount
                                    </label>
                                    <input
                                        className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline h-9"
                                        name="BalanceAmount"
                                        value={formDataReceiptCheckOut.BalanceAmount}
                                        onChange={handleCheckoutChange}
                                        type="text"
                                        placeholder="Enter Balance Amount"
                                        required
                                        style={{ backgroundColor: '#DFF2EB', fontWeight: 'bolder', color: 'black', textAlign: 'right' }}
                                        onClick={(e) => e.target.select()}
                                        disabled
                                    />
                                </div>

                                <div className="w-1/4 mr-2">
                                    <label
                                        className="block uppercase tracking-wide text-xs font-bold mb-2"
                                        htmlFor="grandTotal"
                                    >
                                        Discount
                                    </label>
                                    <input
                                        className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline h-9"
                                        name="AdditionalDiscount"
                                        value={formDataReceiptCheckOut.AdditionalDiscount || '0'}
                                        onChange={handleCheckoutChange}
                                        type="number"
                                        placeholder="Enter Additional Discount"
                                        style={{ fontWeight: 'bolder', color: 'black', textAlign: 'right' }}
                                        max={parseFloat(formDataReceiptCheckOut.BalanceAmount) || 0}
                                    />

                                </div>


                                <div className="w-1/4 mr-2">
                                    <label
                                        className="block uppercase tracking-wide text-xs font-bold mb-2"
                                        htmlFor="grandTotal"
                                    >
                                        Paid Amount
                                    </label>
                                    <input
                                        className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline h-9"
                                        name="PaidAmount"
                                        value={formDataReceiptCheckOut.PaidAmount || 0}
                                        onChange={(e) => {
                                            const newValue = parseFloat(e.target.value) || 0;
                                            const grandTotal = parseFloat(formDataReceiptCheckOut.GrandTotal) || 0;
                                            const discount = parseFloat(formDataReceiptCheckOut.AdditionalDiscount) || 0;

                                            const maxAllowed = Math.max(0, grandTotal - discount);

                                            if (newValue <= maxAllowed) {
                                                handleCheckoutChange(e);
                                            }
                                        }}
                                        type="number"
                                        placeholder="Enter Paid Amount"
                                        required
                                        style={{ fontWeight: 'bolder', color: 'black', textAlign: 'right' }}
                                        onClick={(e) => e.target.select()}
                                        max={
                                            Math.max(
                                                0,
                                                (parseFloat(formDataReceiptCheckOut.GrandTotal) || 0) -
                                                (parseFloat(formDataReceiptCheckOut.AdditionalDiscount) || 0)
                                            )
                                        }
                                    />
                                </div>



                                <div className="w-1/4 mr-2">
                                    <label
                                        className="block uppercase tracking-wide text-xs font-bold mb-2"
                                        htmlFor="grandTotal"
                                    >
                                        Other Amount
                                    </label>
                                    <input
                                        className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline h-9"
                                        name="OtherAmount"
                                        value={formDataReceiptCheckOut.OtherAmount || 0}
                                        onChange={handleCheckoutChange}
                                        type="number"
                                        placeholder="Enter "
                                        required
                                        style={{ fontWeight: 'bolder', color: 'black', textAlign: 'right' }}
                                        onClick={(e) => e.target.select()}
                                    />
                                </div>

                                <div className="w-1/4 mr-2">
                                    <label
                                        className="block uppercase tracking-wide text-xs font-bold mb-2"
                                        htmlFor="grandTotal"
                                    >
                                        Total Amount
                                    </label>
                                    <input
                                        className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline h-9"
                                        name="TotalAmount"
                                        value={formDataReceiptCheckOut.TotalAmount}
                                        onChange={handleCheckoutChange}
                                        type="text"
                                        placeholder="Enter Grand Total"
                                        required
                                        style={{ backgroundColor: '#DFF2EB', fontWeight: 'bolder', color: 'black', textAlign: 'right' }}
                                    />
                                </div>

                            </div>

                            <div className="w-1/2 mr-4" style={{ marginTop: '23px' }}>
                                <button
                                    variant="contained"
                                    className="bg-green-700 text-white px-4 py-2 rounded"
                                    onClick={AddCheckOut}
                                    style={{ marginLeft: '8px', fontSize: '12px', fontWeight: 'bold' }}
                                >
                                    SAVE & CHECK OUT
                                </button>
                                <button
                                    variant="contained"
                                    className="bg-orange-500 text-white px-4 py-2 rounded ml-2"
                                    onClick={toggleModal1}
                                    style={{ marginLeft: '8px', fontSize: '12px', fontWeight: 'bold' }}
                                >
                                    CANCEL
                                </button>
                            </div>
                        </div>
                    </div>
                )
            }

            {
                isModalItemdetailsOpen && (
                    <div className="fixed inset-0 flex items-center justify-center z-10">
                        <div
                            className="bg-white p-6 rounded-lg shadow-lg"
                            style={{ width: "55%", maxHeight: "400px", overflowY: "auto" }}
                        >
                            <h6
                                style={{
                                    color: "brown",
                                    textAlign: "center",
                                    fontWeight: "bolder",
                                    marginBottom: "20px",
                                }}
                            >
                                ITEMS
                            </h6>

                            {/* Flex container for items */}
                            <div
                                style={{
                                    display: "grid",
                                    gridTemplateColumns: "1fr 1fr",
                                    gap: "10px",
                                    alignItems: "flex-start",
                                }}
                            >
                                {Array.isArray(ItemDetails) && ItemDetails.length > 0 ? (
                                    ItemDetails.map((item) => (
                                        <div
                                            key={item.Id}
                                            style={{
                                                display: "flex",
                                                alignItems: "center",
                                                width: "100%",
                                            }}
                                        >
                                            <input
                                                type="checkbox"
                                                id={`item-${item.Id}`}
                                                name={`item-${item.Id}`}
                                                value={item.Name}
                                                onChange={(e) => {
                                                    if (e.target.checked) {
                                                        handleItemSelection(item.Id, "Id", item.Id);
                                                    } else {
                                                        setSelectedItems1((prev) =>
                                                            prev.filter((i) => i.Id !== item.Id)
                                                        );
                                                    }
                                                }}
                                                style={{
                                                    marginRight: "10px",
                                                    width: "10px",
                                                    height: "10px",
                                                    transform: "scale(1.5)",
                                                    cursor: "pointer",
                                                }}
                                            />

                                            <label
                                                htmlFor={`item-${item.Id}`}
                                                style={{
                                                    fontSize: "14px",
                                                    fontWeight: "bold",
                                                    marginRight: "20px",
                                                }}
                                            >
                                                {item.Name}
                                            </label>

                                            {/* Conditionally display Qty and Rate */}
                                            {isSelected(item.Id) && (
                                                <>
                                                    {/* <input
                                                        type="number"
                                                        placeholder="Quantity"
                                                        style={{ width: "50px", marginRight: "10px" }}
                                                        onChange={(e) =>
                                                            handleItemChange(item.Id, "Quantity", e.target.value)
                                                        }
                                                        onClick={(e) => e.target.select()}
                                                    /> */}

                                                    <input
                                                        type="number"
                                                        defaultValue={1}
                                                        placeholder="Qty"
                                                        style={{
                                                            width: "60px",
                                                            padding: "6px 8px",
                                                            border: "1px solid #ccc",
                                                            borderRadius: "5px",
                                                            fontSize: "14px",
                                                            marginRight: "10px",
                                                            outline: "none",
                                                            transition: "border 0.2s",
                                                        }}
                                                        onFocus={(e) => (e.target.style.border = "1px solid #007BFF")}
                                                        onBlur={(e) => (e.target.style.border = "1px solid #ccc")}
                                                        onChange={(e) => handleItemChange(item.Id, "Quantity", e.target.value)}
                                                        onClick={(e) => e.target.select()}
                                                    />


                                                </>
                                            )}
                                        </div>
                                    ))
                                ) : (
                                    <p style={{ marginLeft: "20px" }}>No items available.</p>
                                )}
                            </div>

                            {/* Action buttons */}
                            <div style={{ marginTop: "20px", textAlign: "center" }}>

                                <button
                                    variant="contained"
                                    className="bg-green-700 text-white px-4 py-2 rounded"
                                    onClick={() => AddItemRecord(selectedItems)}
                                    style={{ marginLeft: '8px', fontSize: '12px', fontWeight: 'bold' }}
                                >
                                    ADD RECORD
                                </button>
                                <button
                                    variant="contained"
                                    className="bg-orange-500 text-white px-4 py-2 rounded ml-2"
                                    onClick={toggleModal2}
                                    style={{ marginLeft: '8px', fontSize: '12px', fontWeight: 'bold' }}
                                >
                                    CANCEL
                                </button>
                            </div>
                        </div>
                    </div>

                )
            }

        </div >

    );
};

export default RoomRegisterDetails;